/** Навигация портала uchetkm.ru (маркетинг / сервисы, не редактор). */

export const SITE_BRAND = {
  name: "УчётКМ",
  accent: ".ru",
  title: "УчётКМ.ru",
  tagline:
    "Сервисы для работы с маркировкой и Честным Знаком для предпринимателей.",
} as const

export const SITE_NAV = {
  home: { href: "/", label: "Главная" },
  labels: { href: "/labels", label: "Конструктор этикеток" },
  km: { href: "/km", label: "Коды Маркировки" },
  support: { href: "/support", label: "Поддержка" },
  login: { href: "/login", label: "Войти" },
  profile: { href: "/profile", label: "Профиль" },
  typography: { href: "/typography", label: "Типографика" },
} as const

/** Левая навигация кабинета `/profile/*` (без дашборда — он на `/profile`). */
export const PROFILE_NAV = [
  { href: "/profile/account", label: "Мои данные" },
  { href: "/profile/company", label: "Моя компания" },
  { href: "/profile/apps", label: "API приложения" },
  { href: "/profile/1c", label: "Интеграция с 1С" },
  { href: "/profile/billing", label: "Тарифы и платежи" },
] as const

export const KM_WORKSPACE_URL = "/km"
export const SITE_SERVICES = [
  {
    href: "/services/dmcopy",
    label: "DMCopy — дублирование кодов",
    description:
      "Программа для Windows: дублирование КМ, CSV для ЭДО и print-сервер.",
  },
  {
    href: "/services/dmcopy-online",
    label: "Дублирование КМ онлайн",
    description:
      "Копия Честного Знака и дубль кодов маркировки в браузере: превью, PNG и PDF.",
  },
  {
    href: "/services/edo-xml",
    label: "ЭДО XML",
    description: "УПД ЭДО 5.03: контрагенты, правка товаров и ID абонентов, скачивание XML.",
  },
  {
    href: "/services/compare-excel",
    label: "Сравнить Excel",
    description: "Сверка списков кодов маркировки из Excel и CSV.",
  },
  {
    href: "/services/merge-pdf",
    label: "Объединить в PDF",
    description: "Склейка PDF и изображений в один документ.",
  },
  {
    href: "/services/chzpdf",
    label: "DataMatrix из PDF",
    description: "Извлечение кодов DataMatrix из PDF и фото этикеток.",
  },
  {
    href: "/services/dmrepair",
    label: "Восстановление Datamatrix",
    description: "Восстановление повреждённых и нечитаемых штрихкодов DataMatrix.",
  },
] as const

/** Карточки каталога на главной (A+C): иконка + список действий. */
export const SITE_HOME_CATALOG = [
  {
    id: "km",
    href: "/km",
    label: "Коды Маркировки",
    description: "Реестр товаров по GTIN, пулы марок и печать этикеток.",
    actions: [
      { href: "/km", label: "Открыть реестр" },
      { href: "/km/packs", label: "Пакеты КМ" },
      { href: "/km/import", label: "Загрузить коды" },
    ],
  },
  {
    id: "labels",
    href: "/labels",
    label: "Конструктор этикеток",
    description: "Макеты с DataMatrix, штрихкодами и QR — печать на принтере этикеток.",
    actions: [
      { href: "/labels", label: "Открыть редактор" },
    ],
  },
  {
    id: "dmcopy",
    href: "/services/dmcopy",
    label: "DMCopy — дублирование кодов",
    description:
      "Программа для Windows: скан → этикетка, CSV для ЭДО, print-сервер и мобильное приложение.",
    actions: [
      { href: "/services/dmcopy", label: "Скачать для Windows" },
      { href: "/services/dmcopy-online", label: "Онлайн в браузере" },
      { href: "/services/dmcopy#print-server", label: "Print-сервер" },
    ],
  },
  {
    id: "dmcopy-online",
    href: "/services/dmcopy-online",
    label: "Дублирование КМ онлайн",
    description:
      "Копия Честного Знака и дубль кодов маркировки: фото или сканер → PNG и PDF.",
    actions: [
      { href: "/services/dmcopy-online", label: "Открыть сервис" },
      { href: "/services/dmcopy", label: "DMCopy Pro" },
    ],
  },
  {
    id: "dmrepair",
    href: "/services/dmrepair",
    label: "Восстановление Datamatrix",
    description:
      "Повреждённый код Честного Знака по фото: выравнивание, правка модулей, PNG и этикетка 58×40.",
    actions: [
      { href: "/services/dmrepair", label: "Загрузить фото" },
      { href: "/services/dmrepair", label: "Печать этикетки 58×40" },
    ],
  },
  {
    id: "edo-xml",
    href: "/services/edo-xml",
    label: "ЭДО XML",
    description: "XML УПД ЭДО 5.03: правка товаров и ID абонентов, скачивание файла.",
    actions: [
      { href: "/services/edo-xml", label: "Загрузить XML" },
      { href: "/services/edo-xml", label: "Править товары" },
      { href: "/services/edo-xml", label: "Скачать XML" },
    ],
  },
  {
    id: "compare-excel",
    href: "/services/compare-excel",
    label: "Сравнить Excel",
    description: "Сверка кодов маркировки: пересечение, остаток пула и чужие коды в ГТД.",
    actions: [
      { href: "/services/compare-excel", label: "Загрузить два файла" },
      { href: "/services/compare-excel", label: "Скачать расхождения" },
    ],
  },
  {
    id: "merge-pdf",
    href: "/services/merge-pdf",
    label: "Объединить в PDF",
    description: "Склейка PDF и изображений в один документ.",
    actions: [
      { href: "/services/merge-pdf", label: "Склеить файлы" },
      { href: "/services/merge-pdf", label: "Порядок страниц" },
    ],
  },
  {
    id: "chzpdf",
    href: "/services/chzpdf",
    label: "DataMatrix из PDF",
    description: "Извлечение кодов DataMatrix из PDF и фото этикеток.",
    actions: [
      { href: "/services/chzpdf", label: "Загрузить PDF" },
      { href: "/services/chzpdf", label: "Экспорт кодов" },
    ],
  },
  {
    id: "gtd-codes",
    href: "/services/gtd-codes",
    label: "Коды маркировки из ГТД",
    description: "Получение кодов маркировки из грузовых таможенных деклараций.",
    actions: [
      { href: "/services/gtd-codes", label: "Загрузить ГТД" },
      { href: "/services/gtd-codes", label: "Список кодов" },
    ],
  },
] as const

/** Юридические страницы бренда ucheta.ru (общие для экосистемы). */
export const SITE_LEGAL = [
  { href: "https://ucheta.ru/privacy", label: "Политика конфиденциальности" },
  { href: "https://ucheta.ru/terms", label: "Пользовательское соглашение" },
  { href: "https://ucheta.ru/dpa", label: "Обработка персональных данных (DPA)" },
  {
    href: "https://ucheta.ru/payment-terms",
    label: "Правила оплаты и возврата",
  },
  { href: "https://ucheta.ru/privacy", label: "Политика Cookies" },
] as const

export const SITE_PRODUCT_LINKS = [
  { href: "/km", label: "Коды Маркировки" },
  { href: "/labels", label: "Конструктор этикеток" },
  { href: "https://ucheta.ru/pricing", label: "Тарифы" },
  { href: "/typography", label: "Типографика" },
] as const

export const SITE_CONTACTS = {
  email: "info@ucheta.ru",
  telegramUrl: "https://t.me/ucheta_bot",
  telegramLabel: "@ucheta_bot",
} as const

export type PortalBreadcrumb = { href?: string; label: string }

/** Подписи сегментов URL для хлебных крошек портала. */
const BREADCRUMB_SEGMENT_LABELS: Record<string, string> = {
  support: SITE_NAV.support.label,
  typography: SITE_NAV.typography.label,
  login: SITE_NAV.login.label,
  profile: SITE_NAV.profile.label,
  account: "Мои данные",
  company: "Моя компания",
  apps: "API приложения",
  "1c": "Интеграция с 1С",
  billing: "Тарифы и платежи",
  km: SITE_NAV.km.label,
  packs: "Пакеты КМ",
  codes: "Все коды",
  inventory: "Инвентаризации",
  attributes: "Справочники",
  settings: "Настройки GTIN",
  import: "Импорт",
  "forgot-password": "Восстановление пароля",
  "reset-password": "Новый пароль",
  services: "Сервисы",
  "merge-pdf": "Объединить в PDF",
  "compare-excel": "Сравнить Excel",
  "edo-xml": "ЭДО XML",
  chzpdf: "DataMatrix из PDF",
  result: "Результат",
  "datamatrix-pdf": "DataMatrix из PDF",
  "gtd-codes": "Коды маркировки из ГТД",
  dmrepair: "Восстановление Datamatrix",
  dmcopy: "DMCopy — дублирование кодов",
  "dmcopy-online": "Дублирование КМ онлайн",
}

export type PortalPagesIndexLike = Record<
  string,
  { title?: string; is_published?: boolean }
>

/**
 * Крошки для внутренних страниц портала (без главной).
 * Главная `/` → пустой массив (крошки не показываем).
 * Сегменты без своей страницы (например `/services`) — без href.
 * Для CMS-страниц title берётся из pagesIndex (slug → title).
 */
export function getPortalBreadcrumbs(
  pathname: string,
  pagesIndex: PortalPagesIndexLike = {},
): PortalBreadcrumb[] {
  const path = pathname.split("?")[0]?.replace(/\/+$/, "") || "/"
  if (path === "/" || path === "") return []

  /** Пути-категории без отдельной страницы */
  const nonLinkSegments = new Set(["services"])

  const segments = path.split("/").filter(Boolean)
  const crumbs: PortalBreadcrumb[] = [{ href: "/", label: SITE_NAV.home.label }]
  const fullSlug = segments.join("/")
  const cmsTitle = pagesIndex[fullSlug]?.title

  let acc = ""
  segments.forEach((segment, index) => {
    acc += `/${segment}`
    const isLast = index === segments.length - 1
    const partialSlug = segments.slice(0, index + 1).join("/")
    const indexTitle = pagesIndex[partialSlug]?.title
    const label =
      (isLast && cmsTitle ? cmsTitle : null) ??
      indexTitle ??
      (segments[index - 1] === "import" && segment === "gtin"
        ? "Импорт GTIN"
        : null) ??
      BREADCRUMB_SEGMENT_LABELS[segment] ??
      (segments[index - 1] === "packs"
        ? "Пакет КМ"
        : segments[index - 1] === "codes"
          ? "КИЗ"
          : segments[index - 1] === "inventory"
            ? "Инвентаризация"
            : decodeURIComponent(segment).replace(/-/g, " "))
    if (isLast || nonLinkSegments.has(segment)) {
      crumbs.push({ label })
    } else {
      crumbs.push({ href: acc, label })
    }
  })

  return crumbs
}
